export const REQUIRED_NOMINATION_COUNT = 4;
export const MAX_NOMINATION_COUNT = 6;
// Safety ceiling for how high an admin can raise a placement's nomination
// target. This is not a product limit - it exists only so a malformed request
// can't set an absurd target that would break slot rendering in the UI.
export const NOMINATION_LIMIT_SANITY_MAX = 100;

// The effective maximum for a placement: its admin-set override, or the default.
export function resolveMaxNominations(maxNominations: number | null): number {
  return maxNominations ?? MAX_NOMINATION_COUNT;
}

// The target number of nominations a placement needs: the base requirement plus
// every extra the admin requested. "Request another nomination" raises the cap
// above the default, so each request lifts the target by one: default cap 6 -> 4
// required; cap 8 (two requests) -> 6.
export function resolveRequiredNominations(maxNominations: number | null): number {
  return REQUIRED_NOMINATION_COUNT + (resolveMaxNominations(maxNominations) - MAX_NOMINATION_COUNT);
}

// How many nomination slots the student still needs to fill, given a target of
// `required` (= base + admin-requested extras). Both active and rejected
// nominations count toward the target: a rejection is never held against the
// student, so it doesn't force a replacement - it fills the slot it was
// submitted for. Each admin-requested extra raises `required` by one, so it
// asks for exactly one more nomination on top of what has been provided.
export function outstandingNominationSlots(
  activeCount: number,
  rejectedCount: number,
  required: number,
): number {
  return Math.max(0, required - (activeCount + rejectedCount));
}
